import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _Stimulus;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { DragSource } from 'react-dnd';
import { List, Map } from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { jsx } from '@instructure/emotion';
import AddContentPopover from '../../quiz/AddContent/Popover';
import StimulusEdit from '../StimulusEdit';
import StimulusShow from '../StimulusShow';
import DragAndDropZone from '../../../shared/drag_and_drop/DragAndDropZone';
import { ItemTypes, dragSource, collectDrag } from '../../../../../common/components/shared/drag_and_drop/dragAndDropUtils';
import wrapWithOutsideClickEmotion from '../../../shared/functionality/componentWithOutsideClickEmotion';
import { DELETE_STIMULUS_DATA, withStyleOverrides } from '@instructure/quiz-common';
import ConnectedQuizEntry from '../../../../../building/components/resources/quizEntry/QuizEntry';
import generateStyle from './styles';
import generateComponentTheme from './theme';
export var Stimulus = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_Stimulus = /*#__PURE__*/function (_Component) {
  function Stimulus() {
    var _this2;
    _classCallCheck(this, Stimulus);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, Stimulus, [].concat(args));
    _defineProperty(_this2, "openDeleteStimulusModal", function () {
      var uiData = Map({
        quizId: _this2.props.quizId,
        stimulusEntry: _this2.props.quizEntry,
        childEntries: _this2.props.childEntries
      });
      _this2.props.setUi(DELETE_STIMULUS_DATA, uiData);
      _this2.props.openDeleteStimulusModal();
    });
    return _this2;
  }
  _inherits(Stimulus, _Component);
  return _createClass(Stimulus, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.makeStyles();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.makeStyles();
    }
  }, {
    key: "shouldDisableDragHandle",
    value: function shouldDisableDragHandle() {
      var _this$props = this.props,
        quizEntries = _this$props.quizEntries,
        quizEntry = _this$props.quizEntry;
      return quizEntries.size === quizEntry.positionSlots + 1;
    }
  }, {
    key: "isQuizContentLocked",
    value: function isQuizContentLocked() {
      var _this$props2 = this.props,
        isContentLockedByBlueprint = _this$props2.isContentLockedByBlueprint,
        lockBlueprintContentEnabled = _this$props2.lockBlueprintContentEnabled;
      return lockBlueprintContentEnabled && isContentLockedByBlueprint;
    }
  }, {
    key: "isPassage",
    value: function isPassage() {
      return this.props.stimulus.passage;
    }
  }, {
    key: "renderChildQuizEntries",
    value: function renderChildQuizEntries() {
      var _this3 = this;
      var nextDisplayPosition = this.props.displayPosition;
      return this.props.childEntries.toArray().map(function (childEntry, idx) {
        var displayPosition = nextDisplayPosition;
        nextDisplayPosition += childEntry.displayPositionSlots;
        return jsx("div", {
          css: _this3.props.styles.quizEntryWrapper,
          key: childEntry.id
        }, jsx(ConnectedQuizEntry, Object.assign({}, _this3.props.propsForQuizEntry(childEntry, displayPosition), {
          stimulusOrientation: _this3.props.stimulusOrientationEnabled ? _this3.props.stimulus.orientation : null
        })), !_this3.props.draggingOnBuild && !_this3.isQuizContentLocked() && jsx(AddContentPopover, {
          allowStimulusCreation: false,
          stimulusId: _this3.props.stimulus.id,
          parentEntryId: _this3.props.quizEntry.id,
          quizId: _this3.props.quizId,
          position: childEntry.position + 1,
          useStimulusTrigger: idx + 1 === _this3.props.childEntries.size
        }));
      });
    }
  }, {
    key: "renderStimulusPanel",
    value: function renderStimulusPanel() {
      var StimulusComponent = this.props.isEditing ? StimulusEdit : StimulusShow;
      var automationPrefix = this.isPassage() ? 'text-block' : 'stimulus';
      var connectDragPreview = this.props.connectDragPreview;
      return connectDragPreview(jsx("div", {
        "data-automation": "sdk-".concat(automationPrefix, "-LeftPanelShow")
      }, jsx(StimulusComponent, {
        bankEntryWarningWrapperProps: this.props.bankEntryWarningWrapperProps,
        connectDragSource: this.props.connectDragSource,
        displayPosition: this.props.displayPosition,
        guid: this.props.guid,
        isBankedContent: this.props.isBankedContent,
        openDeleteStimulusModal: this.openDeleteStimulusModal,
        quizEntries: this.props.quizEntries,
        quizEntry: this.props.quizEntry,
        quizId: this.props.quizId,
        scrollKey: this.props.scrollKey,
        shouldClone: this.props.shouldClone,
        shouldDisableDragHandle: this.shouldDisableDragHandle(),
        stimulus: this.props.stimulus,
        switchOnEditing: this.props.switchOnEditing,
        switchOffEditing: this.props.switchOffEditing,
        onEditToggle: this.props.onEditStimulusToggle,
        shouldFocusOnMount: this.props.editStimulusToggle,
        isQuizContentLocked: this.isQuizContentLocked()
      })));
    }
  }, {
    key: "renderPanels",
    value: function renderPanels(propsForDnDZone) {
      var automationPrefix = this.isPassage() ? 'text-block' : 'stimulus';
      return jsx("div", {
        css: this.props.styles.stimulus,
        ref: this.props.dndRef,
        "data-automation": "sdk-".concat(automationPrefix)
      }, jsx("div", {
        css: this.props.styles.leftPanel
      }, this.renderStimulusPanel()), jsx("div", {
        css: this.props.styles.itemPanel
      }, jsx("div", null), this.renderChildQuizEntries(), !this.isPassage() && jsx(DragAndDropZone, Object.assign({}, propsForDnDZone, {
        location: "in"
      })), this.props.childEntries.size === 0 && !this.isQuizContentLocked() && !this.isPassage() && jsx(AddContentPopover, {
        allowStimulusCreation: false,
        stimulusId: this.props.stimulus.id,
        parentEntryId: this.props.quizEntry.id,
        quizId: this.props.quizId,
        position: this.props.quizEntry.position + 1,
        useStimulusTrigger: true
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var propsForDnDZone = {
        inStimulus: true,
        draggingOver: this.props.draggingOver,
        draggingAboveHalf: this.props.draggingAboveHalf,
        dropIntoEmptyStimulus: this.props.dropIntoEmptyStimulus
      };
      return jsx("div", {
        tabIndex: "-1"
      }, jsx("div", null, jsx(DragAndDropZone, Object.assign({}, propsForDnDZone, {
        location: "above"
      })), this.renderPanels(propsForDnDZone), jsx(DragAndDropZone, Object.assign({}, propsForDnDZone, {
        location: "below"
      }))));
    }
  }]);
}(Component), _defineProperty(_Stimulus, "displayName", 'Stimulus'), _defineProperty(_Stimulus, "componentId", "Quizzes".concat(_Stimulus.displayName)), _defineProperty(_Stimulus, "propTypes", {
  bankEntryWarningWrapperProps: PropTypes.func,
  childEntries: ImmutablePropTypes.listOf(ImmutablePropTypes.record).isRequired,
  connectDragPreview: PropTypes.func.isRequired,
  connectDragSource: PropTypes.func.isRequired,
  dndRef: PropTypes.func,
  draggingOnBuild: PropTypes.bool,
  draggingOver: PropTypes.bool.isRequired,
  draggingAboveHalf: PropTypes.bool.isRequired,
  dropIntoEmptyStimulus: PropTypes.bool,
  displayPosition: PropTypes.number.isRequired,
  isBankedContent: PropTypes.bool,
  isContentLockedByBlueprint: PropTypes.bool.isRequired,
  isEditing: PropTypes.bool,
  guid: PropTypes.string.isRequired,
  lockBlueprintContentEnabled: PropTypes.bool.isRequired,
  openDeleteStimulusModal: PropTypes.func.isRequired,
  propsForQuizEntry: PropTypes.func.isRequired,
  quizEntry: ImmutablePropTypes.record.isRequired,
  quizEntries: ImmutablePropTypes.list.isRequired,
  quizId: PropTypes.string.isRequired,
  scrollKey: PropTypes.string,
  setUi: PropTypes.func.isRequired,
  shouldClone: PropTypes.bool.isRequired,
  stimulus: ImmutablePropTypes.record.isRequired,
  switchOnEditing: PropTypes.func.isRequired,
  switchOffEditing: PropTypes.func.isRequired,
  onEditStimulusToggle: PropTypes.func.isRequired,
  editStimulusToggle: PropTypes.bool.isRequired,
  stimulusOrientationEnabled: PropTypes.bool.isRequired,
  makeStyles: PropTypes.func,
  styles: PropTypes.object
}), _defineProperty(_Stimulus, "defaultProps", {
  bankEntryWarningWrapperProps: function bankEntryWarningWrapperProps() {},
  childEntries: List([]),
  dndRef: function dndRef() {},
  draggingOnBuild: false,
  draggingOver: false,
  draggingAboveHalf: false,
  dropIntoEmptyStimulus: false,
  isBankedContent: false,
  isEditing: false,
  lockBlueprintContentEnabled: false,
  onEditStimulusToggle: function onEditStimulusToggle() {},
  scrollKey: '',
  isContentLockedByBlueprint: false
}), _Stimulus)) || _class);
export default DragSource(ItemTypes.QUIZ_ENTRY, dragSource, collectDrag)(wrapWithOutsideClickEmotion(Stimulus));